import {useContext, useEffect} from "react";
import {WooSimpleContext} from "../WooSimpleContext";
import React from "react";
import ProductsLoading from './ProductsLoading';
import Product from './Product';

const ProductsByIds = ({carousel}) => {
    const {products, pagedState, acctCustomer} = useContext(WooSimpleContext);
    const [paged] = pagedState;
    const wooProducts = document.querySelector('[data-woo-products]');
    useEffect(() => {
        if (carousel && wooProducts) {
            window.glideStart();
        }
    });
    return (
        <ul className={carousel ? "slide-slides products" : "products"} data-woo-products>
            {products.loading === true && carousel === false ?
                <ProductsLoading size={paged.size}/>:
                products.data && products.data.products.nodes.map((product, index) => (
                    <Product key={index} acctCustomer={acctCustomer} product={product} />
                ))}
        </ul>
    );
};

export default ProductsByIds;